import { createTestIds } from '@duke-hq/lib';

export const testIds = createTestIds('ui-components-Modals', ['FormModalWrapper']);
